<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="justify-center">{{
          $t("common.invoice")
        }}</v-card-title>

        <v-divider></v-divider>
        <br />

        <v-card-text class="text-center">
          <v-spacer></v-spacer>

          <span>
            {{ $t("modal.doYouWantToReceiveYourTicketInvoiceInYour") }}
            <strong style="text-transform: uppercase; font-size: large"
              >E-MAIL</strong
            >?
          </span>

          <v-spacer></v-spacer>
          <v-text-field
            v-model="email"
            :loading="loading"
            :disabled="loading"
          ></v-text-field>
          <v-spacer></v-spacer>

          <Factura ref="facturaRef" />

          <v-btn
            v-if="!loading"
            @click="confirmPayment(false)"
            color="light"
            text
            style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
          >
            <font-awesome-icon
              icon="times-circle"
              :style="{ color: '#ea2222', fontSize: 50 }"
            />
          </v-btn>

          <v-btn
            v-if="!loading"
            @click="confirmPayment(true)"
            color="light"
            text
            style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
          >
            <font-awesome-icon
              icon="check-circle"
              :style="{ color: '#11bd11', fontSize: 50 }"
            />
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { savePayment } from "@/collections/payments";
import firebaseMixin from "@/mixins/firebase/firebaseMixin";
import Factura from "@/components/public/common/Factura";
import moment from "moment";
import { updateSetting } from "@/collections/settings";
export default {
  name: "FacturaDialog",
  mixins: [firebaseMixin],
  components: {
    Factura
  },
  data() {
    return {
      amount: 0,
      loading: false,
      paymentType: "amount",
      dialog: false,
      selectedProducts: [],
      paymentMode: null
    };
  },
  computed: {
    email() {
      return this.$store.getters.getEmail(false);
    },
    tableQR() {
      return this.$store.state.tableQR;
    }
  },
  methods: {
    async confirmPayment(receipt_is_sent) {
      this.loading = true;
      await this.savePayment(receipt_is_sent);

      this.dialog = false;

      this.showSuccessMessage(
        `Petición de pago ${
          this.paymentMode === "cash" ? "en efectivo enviada" : "con Datáfono"
        }`
      );
      this.loading = false;
    },
    async savePayment(receipt_is_sent) {
      let nextNumber = await this.getNextNumber();
      let now = moment().format();
      let nextInvoiceNumber =
        this.$refs.facturaRef.invoiceRequest === true
          ? await this.getNextInvoiceNumber()
          : "";

      let payment = {
        tableQR: this.tableQR,
        email: this.email,
        receipt_is_sent: receipt_is_sent,
        amount_paid_by_user: null,
        payment_method: this.paymentMode,
        selectedProducts: this.selectedProducts,
        cash_payment: {
          amount_to_pay:
            this.paymentMode === this.paymentMethodCash ? this.amount : null,
          amount_paid: null,
          change: null
        },
        datafono_payment: {
          amount_to_pay:
            this.paymentMode === this.paymentMethodDatafono
              ? this.amount
              : null,
          amount_paid:
            this.paymentMode === this.paymentMethodDatafono ? this.amount : null
        },
        number: nextNumber,
        legal_number:
          this.$refs.facturaRef.invoiceRequest === true
            ? nextInvoiceNumber || nextNumber
            : nextNumber,
        payment_type: this.paymentType,
        payment_on: null,
        invoiceRequest: this.$refs.facturaRef.invoiceRequest,
        company: {
          name: this.$refs.facturaRef.invoiceRequest
            ? this.$refs.facturaRef.company.name
            : "",
          address: this.$refs.facturaRef.invoiceRequest
            ? this.$refs.facturaRef.company.address
            : "",
          nif: this.$refs.facturaRef.invoiceRequest
            ? this.$refs.facturaRef.company.nif
            : "",
          postal_code: this.$refs.facturaRef.invoiceRequest
            ? this.$refs.facturaRef.company.postal_code
            : "",
          city: this.$refs.facturaRef.invoiceRequest
            ? this.$refs.facturaRef.company.city
            : ""
        },
        isAddedToSummary: false,
        updated_on: now
      };
      if (this.$refs.facturaRef.invoiceRequest) {
        let data = this.settings;
        data.company.prev_inv_number = nextInvoiceNumber;
        await updateSetting("settings", data);
      }
      return await savePayment(Date.now().toString(), payment);
    },
    openDialog(amount = 0, canBeDivide, selectedProducts, paymentMode) {
      this.amount = amount;
      this.paymentType = canBeDivide;
      this.dialog = true;
      this.selectedProducts = selectedProducts;
      this.paymentMode = paymentMode;
      setTimeout(() => {
        this.$refs.facturaRef.invoiceRequest = false;
        this.$refs.facturaRef.company.name = "";
        this.$refs.facturaRef.company.address = "";
        this.$refs.facturaRef.company.nif = "";
        this.$refs.facturaRef.company.postal_code = "";
        this.$refs.facturaRef.company.city = "";
      }, 100);
    }
  }
};
</script>
